import { createContext } from 'react';
import update from 'immutability-helper';
import {
    ISearchPageAction,
    ISearchPageProps,
    ISearchPageState,
    SEARCH_PAGE_ACT_TYPE,
} from '../interface';

const SearchPageContext = createContext<ISearchPageProps>({} as ISearchPageProps);

const onSearchPageReducer = (state: ISearchPageState, action: ISearchPageAction): ISearchPageState => {
    const { payload, type: actType } = action;
    switch (actType) {
        case SEARCH_PAGE_ACT_TYPE.INIT_DATA:
        case SEARCH_PAGE_ACT_TYPE.UPDATE_LIST:
        case SEARCH_PAGE_ACT_TYPE.UPDATE_PAGE_TYPE:
        case SEARCH_PAGE_ACT_TYPE.UPDATE_SELECT_LIST:
            return update(state, {
                $merge: { ...payload },
            });
        default:
            return state;
    }
};

export { SearchPageContext, onSearchPageReducer };
